import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getPayinByMerchAndPG,
  getPayoutByMerchAndPG,
  getPayinByMerchId,
  getPayoutByMerchId,
} from "../../config/LiveApi";
import Spinner from "../Spin/Spinner";
import DashboardHeader from "./components/DashboardHeader";
import FirstSection from "./components/FirstSection";
import { toast } from "react-toastify";

const LoadingSpinner = () => <Spinner />;

const MerchantOverview = () => {
  const [merchName, setMerchName] = useState("");
  const [orgName, setOrgName] = useState("");
  const [payInStatistic, setPayInStatistic] = useState(null);
  const [payoutStatistic, setPayoutStatistic] = useState(null);
  const [payInLoading, setPayInLoading] = useState(false);
  const [payoutLoading, setPayoutLoading] = useState(false);
  const [startDate, setStartDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(0, 0, 0, 0));
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    return new Date(today.setHours(23, 59, 59, 999));
  });

  const token = useSelector((store) => store.userReducer.token);
  const [selectedProvider, setSelectedProvider] = useState({
    providerName: "All",
    providerId: null,
    providerType: "",
  });

  const fetchPayInData = async () => {
    try {
      setPayInLoading(true);
      let payInData;
      if (selectedProvider.providerName === "All") {
        payInData = await getPayinByMerchId(
          token,
          merchName,
          startDate.toISOString(),
          endDate.toISOString()
        );
      } else {
        payInData = await getPayinByMerchAndPG(
          token,
          merchName,
          orgName,
          selectedProvider.providerName,
          startDate.toISOString(),
          endDate.toISOString()
        );
      }
      setPayInStatistic(payInData);
    } catch (error) {
        toast.error("Unable to fetch payin data.")
    } finally {
        setPayInLoading(false);
    }
  };

  const fetchPayoutData = async () => {
    try {
      setPayoutLoading(true);
      let payoutData;
      if (selectedProvider.providerName === "All") {
          payoutData = await getPayoutByMerchId(
          token,
          merchName,
          startDate.toISOString(),
          endDate.toISOString()
        );
      } else {
        payoutData = await getPayoutByMerchAndPG(
            token,
            merchName,
            orgName,
          selectedProvider.providerName,
          startDate.toISOString(),
          endDate.toISOString()
        );
      }
      setPayoutStatistic(payoutData);
    } catch (error) {
        toast.error("Unable to fetch payout data.");
    } finally {
      setPayoutLoading(false);
    }
  };

  useEffect(() => {
    if (token && merchName) {
        fetchPayInData();
        fetchPayoutData();
    }
  }, [token, merchName, selectedProvider,startDate,endDate]);
  

  const finalLoading = payInLoading || payoutLoading;

  return (
    <div>
      <DashboardHeader
      onOrgNameChange={setOrgName}
      onMerchNameChange={setMerchName}
      onProviderChange={setSelectedProvider}
      onDateChange={(start, end) => {
        setStartDate(new Date(start));
        setEndDate(new Date(end));
      }}
        merchName={merchName}
      />
     {!merchName ? (
        <div style={{ marginTop: "12rem", textAlign: "center", color: "#777" , fontWeight:700 }}>
          Please select a merchant to view dashboard
        </div>
      ) : finalLoading ? (
        <LoadingSpinner />
      ) : (
        <FirstSection
          payInStatistic={payInStatistic}
          payoutStatistic={payoutStatistic}
          loading={finalLoading}
        />
      )}
    </div>
  );
};

export default MerchantOverview;
